module.exports = __webpack_public_path__ + "static/media/appointment-planning-icon-active.59cd593d.svg";